import { gql } from "@apollo/client";

export const GET_SLIDERS_CAMPAIGNS = gql`
  query {
    getCurrentSliderCampaign {
      orderId
      startTime
      endTime
      cmsTag
      sliders {
        title
        brands {
          image
          brandName
          info
          linkTo
          label
          labelColor
          customUrl
        }
      }
    }
  }
`;
